{
  "password": {
    "backToLogin": "Tillbaka till inloggning",
    "email": {
      "check": "Kontrollera din e-post",
      "description": "Om en användare med den e-postadressen finns, skickar vi ett mejl med instruktioner för att återställa lösenordet.",
      "enter": "Ange e-post",
      "title": "E-post"
    },
    "forgot": {
      "description": "Inga bekymmer, vi skickar återställningsinstruktioner till dig.",
      "title": "Glömt lösenord?"
    },
    "new": "Ange nytt lösenord",
    "repeat": "Upprepa lösenord",
    "reset": {
      "setNew": "Skapa nytt lösenord",
      "subText": "Ditt lösenord har återställts",
      "title": "Återställ lösenord",
      "invalidLink": {
        "title": "Felaktig länk",
        "description": "Denna länk är ogiltig eller har gått ut. Vänligen begär en ny.",
        "requestNewLink": "Begär ny länk"
      }
    },
    "title": "Lösenord",
    "sso": {
      "linked": {
        "title": "Konto länkat!",
        "description": "Ditt konto är nu länkat och du kan framöver logga in med din SSO-leverantör."
      },
      "error": {
        "title": "Ett oväntat fel uppstod",
        "description": "Vänligen försök igen om en stund. Om problemet kvarstår, kontakta oss på support@northhouse.se eller +46 (0)8 50 23 52 22"
      },
      "create": {
        "description": "Logga in med ditt jobbkonto för att slutföra processen."
      },
      "conflict": {
        "title": "Koppling misslyckades",
        "description1": "Ett konto med e-postadressen",
        "description2": "finns redan. Kontakta oss på support@northhouse.se om du behöver hjälp med att koppla ditt konto."
      }
    },
    "activate": {
      "title": "Lösenord aktiverat",
      "description": "Ditt lösenord har aktiverats",
      "toLogin": "Till inloggning"
    }
  }
}
